import * as ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax, Power2 } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

const controller = new ScrollMagic.Controller();

const sectionTeam = document.querySelector('.section-team');

if (sectionTeam) {
    const min = -300;
    const max = -500;

    const tween = new TimelineMax()
        .add([
            TweenMax.fromTo(".section-team__images__item--1", 9, {translateY: min, ease:Power2.easeOut}, {translateY: max, ease:Power2.easeOut}),
            TweenMax.fromTo(".section-team__images__item--2", 6, {translateY: min, ease:Power2.easeOut}, {translateY: max, ease:Power2.easeOut}),
            TweenMax.fromTo(".section-team__images__item--3", 4, {translateY: min, ease:Power2.easeOut}, {translateY: max, ease:Power2.easeOut}),
            TweenMax.fromTo(".section-team__images__item--4", 13, {translateY: min, ease:Power2.easeOut}, {translateY: max, ease:Power2.easeOut}),
            TweenMax.fromTo(".section-team__images__item--5", 6, {translateY: min, ease:Power2.easeOut}, {translateY: max, ease:Power2.easeOut}),
            TweenMax.fromTo(".section-team__images__item--6", 7, {translateY: min, ease:Power2.easeOut}, {translateY: max, ease:Power2.easeOut}),
        ]);

    const offset = window.matchMedia("(min-width: 576px)").matches ? 0 : 80;

    new ScrollMagic.Scene({triggerElement: "#scroll-team", duration: "80%", offset: offset})
        .setPin("#scroll-team")
        .setTween(tween)
        .addTo(controller);
}
